// We don't use the Keycloak adapter in this project, so we have to remove this code
